export const loadState = () => {
    try {
        const serializedSate = window.localStorage.getItem('stateAdmin');
        if (serializedSate === null) {
            return undefined;
        }
        return JSON.parse(serializedSate);
    } catch (error) {
        return undefined;
    }
};

export const removeState = () => {
    try {
        localStorage.removeItem('stateAdmin');
    } catch (error) {
        throw error;
    }
};

export const saveState = (state) => {
    try {
        const serializedSate = JSON.stringify(state);
        localStorage.setItem('stateAdmin', serializedSate);
    } catch (error) {
        throw error;
    }
};
